// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__23N1Q","fullView":"styles_fullView__21wIf"};